export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14123.da8763ae.jpg";